import script from "./FriendItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendItem.vue?vue&type=script&setup=true&lang=js"

import "./FriendItem.vue?vue&type=style&index=0&id=73e23fe5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e23fe5"]])

export default __exports__